import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import Intelligence from "@/pages/Intelligence";

export const Route = createFileRoute("/_app/intelligence/")({
  component: () => (
    <PageGate pageKey="intelligence"><Intelligence /></PageGate>
  ),
});
